const template = require('./help.tpl').default;
module.exports = DomClass(template);
